import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/400-italic.css';
import '@fontsource/noto-sans/700.css';
import '@fontsource/noto-sans/700-italic.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initDatadogLogs } from './global/datadogLogs';
import { Environment } from './global/environment';

initDatadogLogs({
  enabled: Environment.DD_LOGS_ENABLED,
  clientToken: Environment.DD_LOGS_CLIENT_TOKEN,
  service: Environment.DD_SERVICE,
  env: Environment.DD_ENV,
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

const renderApp = () => root.render(<App />);

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', renderApp);
}

renderApp();
